import axios from "axios";
import { useEffect, useState } from "react";
import './CancelSubscription.css'
import { useNavigate } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { post } from "../../../Services/api";


function BillingCancel({ userInfo, billingData }) {
    const [value, setValue] = useState('')
    const [proceed, setProceed] = useState(false)


    async function cancelSubscription() {
        const result = await post("/api/billing/stripe/cancel-subscription", {
            user_id: userInfo.user_id,
            user_email: userInfo.email,
            first_name: userInfo.first_name,
            id: billingData.subscription_id,
            reason: value
        })
        // go to home page
        window.location = '/'
    }

    const handleRadioChange = (event) => {
        setValue(event.target.value);
    };


    return (
        <div>
            {proceed ?
                <div className="flex flex_column gap_40">
                    <h4 className="font_weight_600">Are you sure you want to end your subscription?</h4>

                    <div className="flex flex_wrap gap_20 cancel_subscription_final_stage_buttons_div">
                        <button className="cancel_subscription_proceed_button cursor_pointer" onClick={() => cancelSubscription()}>Cancel Plan</button>
                        <a href="/" className="cancel_subscription_keep_button text_decoration_none flex align_center justify_center cursor_pointer white">Keep Plan</a>
                    </div>
                </div>
                : <div className="flex flex_column gap_40">
                    <h4 className="font_weight_600">We're sorry to hear that you want to leave us...</h4>

                    <div className="flex flex_column gap_12">
                        <p className="font_size_18">What is the reason for wanting to cancel your unlimited plan?</p>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            value={value}
                            onChange={handleRadioChange}
                        >
                            <FormControlLabel value="price" control={<Radio />} label="Price is too high" />
                            <FormControlLabel value="not interested" control={<Radio />} label="No longer using meal planner" />
                            <FormControlLabel value="disappointed" control={<Radio />} label="Not what I expected" />
                            <FormControlLabel value="other" control={<Radio />} label="Other" />
                        </RadioGroup>
                    </div>

                    <div className="cancel_subscription_final_stage_buttons_div flex flex_wrap">
                        {value ? <button className="cancel_subscription_proceed_button cursor_pointer" onClick={() => setProceed(true)}>Proceed</button> : null}

                        <a href="/" className="cancel_subscription_keep_button text_decoration_none flex align_center justify_center cursor_pointer">Keep Plan</a>
                    </div>
                </div>
            }
        </div>
    );
}


export default BillingCancel;